export default {"src":"/_next/static/media/RoadTrafficAccidentsPolytrauma.17f18559.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};